export default {"src":"/_next/static/media/mindfulness-activities-relaxing.mono.4ef8ac90.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};